Ext.ns('mx.comp');

mx.comp.GeoComboBox = Ext.extend(Ext.form.ComboBox, {
    defaultAutoCreate: {tag: 'textarea', autocomplete: 'off', style: {overflow: 'hidden', 'overflow-x': 'auto'}},
    validateOnServer: false, // set to true to allow any address be sent to server
    calculateNearestPoint: false, // set to true, if you want to match non-exact user address with approx. nearest coordinate found by geocoding provider
    strictSearch: false, // set to true, if you want to search landmarks only by name
    alreadyExist: false,
    isCheckValue: false,
    editable: true,
    allowBlank: false,
    grow: true,
    lastQueryString: null,
    growMin: 22,
    growMax: 1000,
    growAppend: '&#160;\n&#160;',
    growPad: 0,
    showMapIcon: true,
    valueField: 'name',
    enableKeyEvents: true,
    geocodingTypes: ['geocoding', 'landmarks'],
    storeUrl: null,
    initComponent: function() {
        if (!this.grow) {
            this.defaultAutoCreate = {tag: 'input', type: 'text', size: '24', autocomplete: 'off'};
        }
        mx.comp.GeoComboBox.superclass.initComponent.call(this, arguments);
        this.tpl =
            '<tpl for="."><div ext:qtip="{' +
            this.displayField +
            '}" class="x-combo-list-item">{' +
            this.displayField +
            '}</div></tpl>';
        var storeParams = {id: 'geo_' + this.name};
        if (this.storeUrl) {
            storeParams['url'] = this.storeUrl;
        }
        this.store = mx.data.GeoPoint.newStore(storeParams);
    },
    getArguments: function() {
        alert("Dear developer, geocoding doesn't work without arguments.");
        return null;
    },
    getValue: function() {
        var v = this.getRawValue();
        if (this.store) {
            var findRecord = this.findRecord(this.valueField, v);
            if (findRecord) {
                return findRecord;
            } else if (this.validateOnServer) {
                return new mx.data.GeoPoint({
                    latitude: null,
                    longitude: null,
                    name: v,
                });
            } else if (this.calculateNearestPoint) {
                return mx.comp.GeoComboBox.superclass.getValue.call(this);
            } else {
                return v;
            }
        } else {
            return v;
        }
    },
    setValue: function(v, silent) {
        if (v) {
            if (v instanceof Ext.data.Record) {
                this.store.add(v);
                this.valueNotFoundText = v && v.get(this.valueField);
                this.lastQueryString = this.valueNotFoundText;
                this.alreadyExist = true;
            }
        } else {
            this.valueNotFoundText = '';
        }
        //        console.log(["address set", v]);
        mx.comp.GeoComboBox.superclass.setValue.apply(this, arguments);
    },
    onSelect: function(record, index) {
        if (this.fireEvent('beforeselect', this, record, index) !== false) {
            this.setValue(record); // was ...(record.data[this.valueField || this.displayField]);
            this.collapse();
            this.fireEvent('select', this, record, index);
            this.fireEvent('change', this);
        }
    },
    // private
    onLoad: function() {
        if (!this.hasFocus) {
            return;
        }
        if (this.store.getCount() > 0 && !this.alreadyExist) {
            this.expand();
            this.restrictHeight();
            if (this.lastQuery == this.allQuery) {
                if (this.editable) {
                    this.el.dom.select();
                }
                if (!this.selectByValue(this.value, true)) {
                    this.select(0, true);
                }
            } else {
                this.selectNext();
                if (
                    this.typeAhead &&
                    this.lastKey != Ext.EventObject.BACKSPACE &&
                    this.lastKey != Ext.EventObject.DELETE
                ) {
                    this.taTask.delay(this.typeAheadDelay);
                }
            }
        } else {
            this.onEmptyResults();
        }
    },
    doQuery: function(q, forceAll) {
        return mx.comp.GeoComboBox.superclass.doQuery.call(this, q, forceAll);
    },

    labels: {
        pointPositionOnMap: 'Point position on map',
        addressInvalid: '{0} is invalid address. Check it on map',
    },

    autoSize: function() {
        if (!this.grow || !this.textSizeEl) {
            return;
        }
        var el = this.el;
        var v = el.dom.value;
        var ts = this.textSizeEl;
        ts.innerHTML = '';
        ts.appendChild(document.createTextNode(v));
        v = ts.innerHTML;

        Ext.fly(ts).setWidth(this.el.getWidth());
        if (v.length < 1) {
            v = '&#160;&#160;';
        } else {
            if (Ext.isIE) {
                v = v.replace(/\n/g, '<p>&#160;</p>');
            }
            v += this.growAppend;
        }
        ts.innerHTML = v;
        var h = Math.min(this.growMax, Math.max(ts.offsetHeight, this.growMin) + this.growPad);
        if (h != this.lastHeight) {
            this.lastHeight = h;
            this.el.setHeight(h);
            this.fireEvent('autosize', this, h);
        }
    },

    onDestroy: function() {
        if (this.textSizeEl) {
            Ext.removeNode(this.textSizeEl);
        }
        mx.comp.GeoComboBox.superclass.onDestroy.call(this);
    },

    getAddress: function() {
        return this.isValid() ? this.getValue() : {name: this.getValue()};
    },

    onRender: function(ct, position) {
        mx.comp.GeoComboBox.superclass.onRender.call(this, ct, position);
        this.el.on(
            'keyup',
            function() {
                this.isCheckValue = true;
                this.onLoadResults(this.getRawValue());
            },
            this,
            {stopEvent: true}
        );

        if (this.grow) {
            this.textSizeEl = Ext.DomHelper.append(document.body, {
                tag: 'pre',
                cls: 'x-form-grow-sizer',
            });
        }

        this.wrap.addClass('mx-comp-geocombobox');

        if (this.showMapIcon) {
            this.geo = Ext.DomHelper.append(
                this.wrap.dom,
                {
                    tag: 'div',
                    cls: 'lookup',
                },
                true
            );

            this.geo.on(
                'click',
                function() {
                    if (this.getArguments() != null) {
                        if (this.mapWindow) {
                            this.mapWindow.destroy();
                        }
                        var address = this.getAddress();
                        this.mapWindow = new mx.app.widget.WindowForm({
                            title: this.labels.pointPositionOnMap,
                            formClass: mx.app.widget.MapForm,
                            editable: true,
                            resizable: true,
                            maximizable: true,
                            width: 650,
                            minHeight: 300,
                            listeners: {
                                ok: {
                                    fn: function() {
                                        this.store.removeAll();
                                        var geoPoint = new mx.data.GeoPoint({
                                            id: 0,
                                            latitude: this.mapWindow.form.inputs.latitudeTextfield.getValue(),
                                            longitude: this.mapWindow.form.inputs.longitudeTextfield.getValue(),
                                            name: this.mapWindow.form.inputs.addressTextfield.getValue(),
                                        });
                                        this.setValue(geoPoint);
                                        this.fireEvent('change', this);
                                    },
                                    scope: this,
                                },
                            },
                            formClassConfig: {
                                params: {
                                    address: address,
                                    mapParams: new mx.comp.MapParams(
                                        Ext.apply(this.getArguments(), mx.data.GeoPoint.geoToMxnPoint(address))
                                    ),
                                },
                            },
                        });
                        if (this.mapWindow.formClassConfig.params.mapParams.valid()) {
                            this.mapWindow.show();
                            this.collapse();
                        }
                    }
                },
                this
            );
        }
    },

    onResize: function(w, h) {
        var geoWidth = this.showMapIcon ? this.geo.getWidth() : 0;
        if (typeof w == 'number') {
            this.el.setWidth(this.adjustWidth('input', w - this.trigger.getWidth() - geoWidth));
        }
        if (this.showMapIcon) {
            this.geo.setLeft(this.el.getWidth() + this.trigger.getWidth());
        }
        this.wrap.setWidth(this.el.getWidth() + this.trigger.getWidth() + geoWidth);
    },

    onTriggerClick: function() {
        this.isCheckValue = false;
        this.lastQueryString = '';
        mx.comp.GeoComboBox.superclass.onTriggerClick.call(this);
        this.onLoadResults(this.getRawValue());
    },

    onLoadResults: function(value) {
        var args = this.getArguments();
        if ((this.lastQueryString == value && value) || !args) {
            return false;
        }
        this.lastQueryString = value;
        args['query'] = this.lastQueryString;
        args['types'] = this.geocodingTypes;
        if (args.region && args.region.data) {
            args.region = args.region.get('id');
        }
        args.calculateNearestPoint = this.calculateNearestPoint;
        args.strictSearch = this.strictSearch;
        this.store.removeAll();
        this.store.un('load', this.onLoad, this);
        this.store.load({
            params: args,
            callback: function(r, o, s) {
                if (this.calculateNearestPoint) {
                    this.valueNotFoundText = this.lastQueryString;
                }
                if (this.isCheckValue) {
                    var scope = this;
                    var res = false;
                    var nearestPointFound = false;
                    r.forEach(function(item) {
                        if (item.get('name') == value) {
                            scope.setValue(item, scope.calculateNearestPoint);
                            scope.fireEvent('change', this);
                            res = true;

                            if (scope.calculateNearestPoint) {
                                // remove queries with the same name:
                                scope.store.suspendEvents();
                                mx.data.Store.superclass.remove.call(
                                    scope.view.store,
                                    scope.view.store.getAt(scope.view.store.find('name', item.get('name')))
                                );
                                scope.store.resumeEvents();
                                scope.view.refresh();
                                res = false;
                                nearestPointFound = true;
                            }
                        }
                    });

                    //                    if(scope.calculateNearestPoint && (!r.length || !nearestPointFound)) {
                    //                        scope.setValue("");
                    //                    }

                    this.alreadyExist = res;
                } else {
                    this.alreadyExist = false;
                }
                this.onLoad(this);
            },
            scope: this,
        });
    },
    validator: function() {
        if (!this.validateOnServer) {
            var address = this.getValue();
            if (
                !address.get ||
                !address.get('name') ||
                !((address.get('longitude') && address.get('latitude')) || address.get('id'))
            ) {
                return String.format(this.labels.addressInvalid, this.getValue());
            } else {
                return true;
            }
        } else {
            return true;
        }
    },
});

Ext.reg('mx-geocombobox', mx.comp.GeoComboBox);
